<template>
  <v-container fluid>
    <v-overlay>
      <v-card light>
        <v-card-title>Page Not Found</v-card-title>
        <v-card-subtitle>Page that you looking for is no longer exist or have been moved</v-card-subtitle>
        <div class="text-center">
          <v-btn elevation class="mt-3 mb-3" color="primary" @click="redirectToHome">
            Back to
            <v-icon class="ml-1">mdi-home</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
export default {
  name: "notFound",
  data() {
    return {
    }
  },
  methods: {
    redirectToHome() {
      this.$router.push({ name: "summary-report" })
    }
  },
  created() { },
  components: {}
};
</script>
